export default (date) => {
  if (!date) return false

  const currentDate = new Date()
  const inputDate = new Date(date)

  const diffTime = Math.abs(currentDate - inputDate)
  const diffHours = diffTime / (1000 * 60 * 60)

  return diffHours <= 48
}
